import {DeviceRelocationService} from "./device-relocation.service";
import {Component} from "@angular/core";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {ActivatedRoute, Router, Params} from "@angular/router";
import {ConfirmDialogService} from "../confirm-dialog/confirm-dialog-service";
import {handleErrors} from "../misc/handle-errors.decorator";

@Component({
  templateUrl: "./device-relocation-details.template.pug",
  providers: [
    DeviceRelocationService,
    ConfirmDialogService,
  ],
})
export class DeviceRelocationDetailsComponent extends RouteHelper {
  public error: Error;
  public id: string;
  public relocation: any;

  public paramsMap: RouteMapping[] = [
    {fieldName: "id", paramName: "id"} as RouteMapping,
  ];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private deviceRelocationService: DeviceRelocationService,
  ) {
    super();
  }

  @handleErrors()
  async loadData(): Promise<void> {
    this.relocation = await this.deviceRelocationService.getDeviceRelocationById(this.id);
  }

  public navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["device-relocation"], {queryParams, skipLocationChange});
  }
}
